(() => {
  const getCookie = (name) => {
    return document.cookie.split('; ').reduce((r, v) => {
      const parts = v.split('=');
      return parts[0] === name ? decodeURIComponent(parts[1]) : r;
    }, '');
  }
  
  const getProducts = () => {
    const products = document.querySelectorAll('.product-card:not(.product-card--done)');
    let productsArray = Array.from(products);
    productsArray = productsArray.map(product => {
      return {
        'id': `${product.dataset.productId}`,
        'variant_id': `${product.dataset.variantId}`,
        'price': `${product.dataset.productPrice}`
      };
    });
    for (const product of products) {
      product.classList.add('product-card--done');
    }
    return productsArray;
  }

  const getSingleProduct = () => {
    return window._product;
  }

  const calculateSingleProductDiscount = () => {
    const discountCode = getCookie('discount_code');
    if (discountCode) {
      let singleProduct = getSingleProduct()
      console.log({singleProduct})
      if (!singleProduct) return;
      const products = [singleProduct];

      let shop = Shopify.shop;
      let formatMoney = false;
      if (!shop) {
        shop = document.querySelector('meta[name="shop"]').getAttribute('content');
      }

      if (!formatMoney) {
        formatMoney = document.querySelector('meta[name="money-format"]').getAttribute('content');
      }
      
      let batchJson = {
        "code": discountCode,
        "shop": shop,
        "products": products
      }

      console.log({batchJson})
      const base64Json = btoa(JSON.stringify(batchJson))
      var url = `https://boxio-shop-checkout-api.ds-apps.de/checkout/batch?data=${base64Json}`
      if (window.themeVariables.settings.shop == 'myboxio.myshopify.com') {
        url = `https://myboxio-checkout-api.ds-apps.de/checkout/batch?data=${base64Json}`
      }
      fetch(url)
          .then(response => response.json())
          .then(returnData => {
              if (returnData != undefined && returnData[0]?.checkout?.checkoutCart?.target_type != 'shipping_line') {
                for (const dataItem of returnData) {
                  if (dataItem.checkout.status == 'invalid') continue
                  if (dataItem.checkout?.checkoutCart?.target_type == 'shipping_line') continue

                  const productCard = document.querySelector(`.product-info .product-info__price`);
                  if (productCard) {
                    const price = productCard.dataset.price;
                    if (dataItem.price?.toString() != dataItem.checkout.checkoutCart.total?.toString()) {
                      const hasCompareAtPrice = !!productCard.querySelector('compare-at-price');
                      if (hasCompareAtPrice) {
                        const salePrice = productCard.querySelector('sale-price');
                        salePrice.textContent = Shopify.formatMoney(dataItem.checkout.checkoutCart.total, formatMoney);
                        salePrice.classList.add('text-on-sale');
                        salePrice.classList.add('text-lg');

                        const priceList = productCard.querySelector(".price-list")
                      
                        const compareAtPrice = productCard.querySelector('compare-at-price');
                        compareAtPrice.textContent = Shopify.formatMoney(dataItem.price, formatMoney);
                        compareAtPrice.classList.add('text-subdued');
                        compareAtPrice.classList.add('line-through');
                        compareAtPrice.removeAttribute("hidden");

                        // Commented out badge creation since we're now handling this in product-info.liquid
                        /*
                        let badge = priceList.querySelector('on-sale-badge');
                        if (!badge && priceList) {
                          badge = document.createElement('on-sale-badge');
                          badge.innerHTML = `${window.themeVariables.strings.onSaleBadge?.replace("@@", "")}`;
                          badge.classList.add("badge")
                          badge.classList.add("badge--lg")
                          badge.classList.add("badge--on-sale")
                          priceList.appendChild(badge);
                        }
                        */
                      } else {
                        const priceList = productCard.querySelector('price-list');
                        if (priceList) {
                          priceList.innerHTML = '';

                          const salePrice = document.createElement('sale-price');
                          salePrice.textContent = Shopify.formatMoney(dataItem.checkout.checkoutCart.total, formatMoney);
                          salePrice.classList.add('text-on-sale');
                          salePrice.classList.add('text-lg');
                          priceList.appendChild(salePrice);

                          const compareAtPrice = document.createElement('compare-at-price');
                          compareAtPrice.textContent = Shopify.formatMoney(dataItem.price, formatMoney);
                          compareAtPrice.classList.add('text-subdued');
                          compareAtPrice.classList.add('line-through');
                          priceList.appendChild(compareAtPrice);
                        }
                      }
                    }
                  }
                }
              }
          });      
    }
  }

  const calculateProductsDiscount = () => {
    const discountCode = getCookie('discount_code');
    if (discountCode) {
      const products = getProducts();
      if (products.length === 0) return;

      let shop = Shopify.shop;
      let formatMoney = false;
      if (!shop) {
        shop = document.querySelector('meta[name="shop"]').getAttribute('content');
      }


      if (!formatMoney) {
        formatMoney = document.querySelector('meta[name="money-format"]').getAttribute('content');
      }
      
      let batchJson = {
        "code": discountCode,
        "shop": shop,
        "products": products
      }
      
      const base64Json = btoa(JSON.stringify(batchJson))
      var url = `https://boxio-shop-checkout-api.ds-apps.de/checkout/batch?data=${base64Json}`
      if (window.themeVariables.settings.shop == 'myboxio.myshopify.com') {
        url = `https://myboxio-checkout-api.ds-apps.de/checkout/batch?data=${base64Json}`
      }
      fetch(url)
          .then(response => response.json())
          .then(returnData => {
              if (returnData != undefined && returnData[0]?.checkout?.checkoutCart?.target_type != 'shipping_line') {
                for (const dataItem of returnData) {
                  if (dataItem.checkout.status == 'invalid') continue
                  if (dataItem.checkout?.checkoutCart?.target_type == 'shipping_line') continue

                  const productCard = document.querySelector(`.product-card[data-product-id="${dataItem.id}"]`);
                  if (productCard) {
                    const price = productCard.dataset.price;
                    if (dataItem.price?.toString() != dataItem.checkout.checkoutCart.total?.toString()) {
                      const hasCompareAtPrice = !!productCard.querySelector('compare-at-price');
                      if (hasCompareAtPrice) {
                        productCard.querySelector('sale-price').textContent = Shopify.formatMoney(dataItem.checkout.checkoutCart.total, formatMoney);
                      } else {
                        const priceList = productCard.querySelector('price-list');
                        if (priceList) {
                          priceList.innerHTML = '';

                          const salePrice = document.createElement('sale-price');
                          salePrice.textContent = Shopify.formatMoney(dataItem.checkout.checkoutCart.total, formatMoney);
                          salePrice.classList.add('text-on-sale');
                          priceList.appendChild(salePrice);

                          const compareAtPrice = document.createElement('compare-at-price');
                          compareAtPrice.textContent = Shopify.formatMoney(dataItem.price, formatMoney);
                          compareAtPrice.classList.add('text-subdued');
                          compareAtPrice.classList.add('line-through');
                          priceList.appendChild(compareAtPrice);
                        }
                      }

                      /*
                      if (hasCompareAtPrice) {
                        productCard.querySelector('sale-price').textContent = Shopify.formatMoney(dataItem.checkout.checkoutCart.total, formatMoney);
                      } else {
                        const priceList = productCard.querySelector('price-list');
                        if (priceList) {
                          priceList.innerHTML = '';

                          const salePrice = document.createElement('sale-price');
                          salePrice.textContent = Shopify.formatMoney(dataItem.checkout.checkoutCart.total, formatMoney);
                          salePrice.classList.add('text-on-sale');
                          priceList.appendChild(salePrice);

                          const compareAtPrice = document.createElement('compare-at-price');
                          compareAtPrice.textContent = Shopify.formatMoney(dataItem.price, formatMoney);
                          compareAtPrice.classList.add('text-subdued');
                          compareAtPrice.classList.add('line-through');
                          priceList.appendChild(compareAtPrice);
                        }
                      }*/
                    }
                  }
                }
              }
          });      
    }

  }

  document.addEventListener('DOMContentLoaded', () => {

    calculateProductsDiscount();
    setInterval(() => {
      calculateProductsDiscount();
    }, 500);
  
    calculateSingleProductDiscount();
  });

})();
